import "../../styles/Home.css";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();

  return (
    <>
      {/* HERO SECTION */}
      <header className="hero">
        <div className="overlay">
              <img src="../../logo.png" alt="Logo del Club" className="club-logo" />
          <h1>¡BIENVENIDO A LA LIGA SANGUILLERMINA!</h1>
          <p>
            Descubrí un espacio donde cada partido se vive con intensidad, donde el nivel crece y la pasión por el pádel se comparte en cada punto.
          </p>
          <button className="boton-reservar" onClick={() => navigate("/registro")}>
            Registrarse
          </button>
        </div>
      </header>
      {/* Botón flotante de WhatsApp */}
        <a
        href="https://wa.me/5493562448870" // Reemplaza con tu número de WhatsApp
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-button"
        >
        <img src="../../whatsapp.png" alt="WhatsApp" />
        </a>





      {/* SECCIÓN: BENEFICIOS AL AFILIARSE */}
      <section className="beneficios-section">
        <div className="container">
          <h2 className="section-title">BENEFICIOS AL AFILIARSE</h2>
          <p className="section-subtitle">Únete a nuestra liga y disfruta de ventajas exclusivas</p>
          
          <div className="beneficios-grid">
            <div className="beneficio-card">
              <div className="beneficio-icon">🏆</div>
              <h3>Torneos Exclusivos</h3>
              <p>Participa en torneos mensuales con premios y reconocimientos para todos los niveles.</p>
            </div>

            <div className="beneficio-card">
              <div className="beneficio-icon">💰</div>
              <h3>Descuentos Especiales</h3>
              <p>Obtén hasta 15% de descuento en reservas de canchas y equipamiento deportivo.</p>
            </div>

            <div className="beneficio-card">
              <div className="beneficio-icon">👥</div>
              <h3>Comunidad Activa</h3>
              <p>Conoce jugadores de tu nivel y crea nuevas amistades en cada partido.</p>
            </div>

            <div className="beneficio-card">
              <div className="beneficio-icon">📊</div>
              <h3>Ranking Personalizado</h3>
              <p>Sigue tu progreso con estadísticas detalladas y compite por el primer lugar.</p>
            </div>

            <div className="beneficio-card">
              <div className="beneficio-icon">🎓</div>
              <h3>Clases Exclusivas</h3>
              <p>Accede a clínicas y entrenamientos mensuales con profesionales certificados.</p>
            </div>

            <div className="beneficio-card">
              <div className="beneficio-icon">🎯</div>
              <h3>Eventos Sociales</h3>
              <p>Disfruta de eventos, fiestas y actividades exclusivas para afiliados.</p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN: SOBRE LA LIGA */}
      <section className="sobre-section">
        <div className="container">
          <div className="sobre-content">
            <div className="sobre-text">
              <h2 className="section-title">SOBRE LA LIGA DE PÁDEL</h2>
              <p className="sobre-description">
                La Liga Sanguillermina es el punto de encuentro para los amantes del pádel. 
                Con más de 5 años de trayectoria, nos hemos convertido en la liga referente 
                de la región, promoviendo el deporte, la competencia sana y la amistad.
              </p>
              <div className="sobre-stats">
                <div className="stat-item">
                  <div className="stat-number">500+</div>
                  <div className="stat-label">Jugadores Activos</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">12</div>
                  <div className="stat-label">Torneos al Año</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">6</div>
                  <div className="stat-label">Categorías</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">100%</div>
                  <div className="stat-label">Compromiso</div>
                </div>
              </div>
              <ul className="sobre-features">
                <li>✓ Instalaciones de primera categoría</li>
                <li>✓ Torneos organizados mensualmente</li>
                <li>✓ Categorías para todos los niveles</li>
                <li>✓ Sistema de ranking actualizado</li>
                <li>✓ Premios y reconocimientos</li>
              </ul>
            </div>
            <div className="sobre-image">
              <img src="../../CanchaPadel.jpg" alt="Cancha de Pádel" />
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN: CONTACTO */}
      <section className="contacto-section">
        <div className="container">
          <h2 className="section-title">CONTACTO</h2>
          <p className="section-subtitle">¿Tienes alguna consulta? Estamos aquí para ayudarte</p>
          
          <div className="contacto-content">
            <div className="contacto-info">
              <div className="info-item">
                <div className="info-icon">📍</div>
                <div>
                  <h4>Ubicación</h4>
                  <p>San Guillermo, Santa Fe, Argentina</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">📧</div>
                <div>
                  <h4>Email</h4>
                  <p>info@ligasanguillermina.com</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">📱</div>
                <div>
                  <h4>Teléfono</h4>
                  <p>+54 9 3562 448870</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">🕒</div>
                <div>
                  <h4>Horarios</h4>
                  <p>Lun - Dom: 8:00 AM - 11:00 PM</p>
                </div>
              </div>

              <div className="redes-sociales">
                <h4>Síguenos</h4>
                <div className="social-icons">
                  <a href="www.facebook.com" className="social-icon"><img src="../../facebook.png" alt=""/></a>
                  <a href="www.google.com" className="social-icon"><img src="../../instagram.png" alt="" /></a>
                  <a href="www.google.com" className="social-icon"><img src="../../twitter.png" alt="" /></a>
                </div>
              </div>
            </div>

            <div className="contacto-form">
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="form-group">
                  <input type="text" placeholder="Tu nombre" required />
                </div>
                <div className="form-group">
                  <input type="email" placeholder="Tu email" required />
                </div>
                <div className="form-group">
                  <input type="tel" placeholder="Tu teléfono" />
                </div>
                <div className="form-group">
                  <textarea placeholder="Tu mensaje" rows="5" required></textarea>
                </div>
                <button type="submit" className="btn-enviar">Enviar Mensaje</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <p>&copy; 2025 Liga Sanguillermina - Todos los derechos reservados</p>
      </footer>
    </>
  );
}